import { Route } from '@angular/router';
import { initialDataResolver } from 'app/app.resolvers';
import { AuthGuard } from 'app/core/auth/guards/auth.guard';
import { NoAuthGuard } from 'app/core/auth/guards/noAuth.guard';
import { LayoutComponent } from 'app/layout/layout.component';
import { RoutineDetonatorComponent } from './modules/admin/apps/routine-detonator/routine-detonator.component';
import { ManualComponent } from '@/apps/routines/manual/manual.component';

// @formatter:off
/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
export const appRoutes: Route[] = [

    // Redirect empty path to '/example'
    { path: '', pathMatch: 'full', redirectTo: 'dashboards' },

    // Redirect signed-in user to the '/example'
    //
    // After the user signs in, the sign-in page will redirect the user to the 'signed-in-redirect'
    // path. Below is another redirection for that path to redirect the user to the desired
    // location. This is a small convenience to keep all main routes together here on this file.
    { path: 'signed-in-redirect', pathMatch: 'full', redirectTo: 'dashboards' },

    // Auth routes for guests
    {
        path: '',
        canActivate: [NoAuthGuard],
        canActivateChild: [NoAuthGuard],
        component: LayoutComponent,
        data: {
            layout: 'empty'
        },
        children: [
            { path: 'confirmation-required', loadChildren: () => import('app/modules/auth/confirmation-required/confirmation-required.routes') },
            { path: 'forgot-password', loadChildren: () => import('app/modules/auth/forgot-password/forgot-password.routes') },
            { path: 'reset-password', loadChildren: () => import('app/modules/auth/reset-password/reset-password.routes') },
            { path: 'sign-in', loadChildren: () => import('app/modules/auth/sign-in/sign-in.routes') },
        ]
    },

    // Auth routes for authenticated users
    {
        path: '',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: LayoutComponent,
        data: {
            layout: 'empty'
        },
        children: [
            { path: 'sign-out', loadChildren: () => import('app/modules/auth/sign-out/sign-out.routes') },
        ]
    },

    // Landing routes
    {
        path: '',
        component: LayoutComponent,
        data: {
            layout: 'empty'
        },
        children: [
            //{path: 'home', loadChildren: () => import('app/modules/landing/home/home.routes')},
            { path: 'event/registration', loadChildren: () => import('app/modules/admin/apps/events/registration/registration.routes') },
            { path: 'event/lider-board', loadChildren: () => import('app/modules/admin/apps/events/lider-board/lider-board.routes') },
            { path: 'cookie-policy', loadChildren: () => import('app/modules/landing/cookie-policy/cookie-policy.routes') },
        ]
    },

    // Admin routes
    {
        path: '',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: LayoutComponent,
        resolve: {
            initialData: initialDataResolver
        },
        children: [
            {
                path: 'dashboards', children: [
                    { path: 'users', loadChildren: () => import('app/modules/admin/apps/users/users.routes') },
                    { path: 'enterprises', loadChildren: () => import('app/modules/admin/apps/enterprises/enterprises.routes') },
                    { path: 'types_devices', loadChildren: () => import('app/modules/admin/apps/types_devices/types_devices.routes') },
                    { path: 'devices', loadChildren: () => import('app/modules/admin/apps/devices/devices.routes') },
                    { path: 'types_plans', loadChildren: () => import('app/modules/admin/apps/types_plans/types_plans.routes') },
                    { path: 'assign_devices', loadChildren: () => import('app/modules/admin/apps/assign-devices/assign-devices.routes') },
                    { path: 'license_payment', loadChildren: () => import('app/modules/admin/apps/license_payment/license_payment.routes') },
                    { path: 'users_manager', loadChildren: () => import('app/modules/admin/apps/users-manager/users-manager.routes') },
                    { path: 'shopping_history', loadChildren: () => import('app/modules/admin/apps/license_payment_clients/license_payment_clients.routes') },
                    { path: 'users_coach', loadChildren: () => import('app/modules/admin/apps/users-coach/users-coach.routes') },
                    { path: 'cluster', loadChildren: () => import('app/modules/admin/apps/cluster/cluster.routes') },
                    { path: 'routines', loadChildren: () => import('app/modules/admin/apps/routines/routines.routes') },
                    { path: 'coach_devices', loadChildren: () => import('app/modules/admin/apps/coach-devices/coach-devices.routes') },
                    { path: 'inventory', loadChildren: () => import('app/modules/admin/apps/inventory/inventory.routes') },
                    { path: 'products_category', loadChildren: () => import('app/modules/admin/apps/products_category/products_category.routes') },
                    { path: 'products_brands', loadChildren: () => import('app/modules/admin/apps/products_brands/products_brands.routes') },
                    { path: 'sales_report', loadChildren: () => import('app/modules/admin/apps/sales_report/sales_report.routes') },
                    { path: 'configuration', loadChildren: () => import('app/modules/admin/apps/configuration/configuration.routes') },
                    { path: 'coach_stats', loadChildren: () => import('app/modules/admin/apps/coach-stats/coach-stats.routes') },
                    { path: 'divisions', loadChildren: () => import('app/modules/admin/apps/divisions/divisions.routes') },
                    { path: 'routine_comparator', loadChildren: () => import('app/modules/admin/apps/routine-comparator/routine-comparator.routes') },
                    { path: 'projects', loadChildren: () => import('app/modules/admin/apps/projects/projects.routes') },
                    { path: 'publications', loadChildren: () => import('app/modules/admin/apps/publications/publications.routes') },
                    { path: 'events', loadChildren: () => import('app/modules/admin/apps/events/events.routes') },
                    { path: 'manage-events', loadChildren: () => import('app/modules/admin/apps/events/manage/manage.routes') },
                    { path: 'results-events', loadChildren: () => import('app/modules/admin/apps/events/results/results.routes') },
                    { path: 'player-routine-detonate', loadChildren: () => import('app/modules/admin/apps/routines/player/routine-detonator/routine-detonator.routes') },
                    { path: 'manage-participants', loadChildren: () => import('app/modules/admin/apps/events/manage-participants/manage-participants.routes') },
                    { path: 'routine_detonator', component: RoutineDetonatorComponent },
                    { path: 'manual', component: ManualComponent },
                ]
            },
        ]
    }
];
